export type PortalRole = 'Admin' | 'Manager' | 'Rep';

export const PORTAL_ROLES: readonly PortalRole[] = ['Admin', 'Manager', 'Rep'];

interface RoleAccess {
  approvals: boolean;
  administration: boolean;
  organizationSales: boolean;
}

export const ROLE_ACCESS: Record<PortalRole, RoleAccess> = {
  Admin: { approvals: true, administration: true, organizationSales: true },
  Manager: { approvals: true, administration: false, organizationSales: true },
  Rep: { approvals: false, administration: false, organizationSales: false },
};

export function canApprove(role: PortalRole | null | undefined): boolean {
  return role ? ROLE_ACCESS[role]?.approvals ?? false : false;
}

export function canAccessAdministration(role: PortalRole | null | undefined): boolean {
  return role ? ROLE_ACCESS[role]?.administration ?? false : false;
}

export function hasOrganizationSalesScope(role: PortalRole | null | undefined): boolean {
  return role ? ROLE_ACCESS[role]?.organizationSales ?? false : false;
}
